export const ADD_STYLE = "ADD_STYLE";

export const addStyle = (styleTab) => {
    return {
        type: ADD_STYLE,
        payload: styleTab
    }
}
